import * as React from "react";
import { Container, Grid} from "@mui/material";
import { useAuth } from "../context/AuthContext";
import ButtonNav from "../components/General/ButtonNav";
import { LEGAL_FILE_SECTIONS } from "../config/navigation/legalFileSections.config";
import { NavIcon } from "../config/navigation/navigation.icons";

export default function LegalFileHome() {
  const { hasPermission } = useAuth();

  const legalFileItems = React.useMemo(() => {
    return LEGAL_FILE_SECTIONS.filter((item) => {
      if (!item.home?.show) return false;
      if (!item.permission) return true;
      return hasPermission(item.permission);
    });
  }, [hasPermission]);

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2}>
        {legalFileItems.map((item) => (
          <Grid key={item.segment} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title={item.title}
              subtitle={item.home?.description}
              icon={<NavIcon iconKey={item.iconKey} />}
              color={item.home?.color}
              to={`/${item.segment}`}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
